import { NgModule } from '@angular/core';
import { RouterModule, Routes, NoPreloading, PreloadAllModules } from '@angular/router';

import { AuthGuard } from "./auth/auth.guard";
import { MapResolver } from "./services/map.resolver";
import { MapsResolver } from "./services/maps.resolver";
import { MapDashboardResolver } from "./services/map-dashboard.resolver";

const routes: Routes = [
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
    },
    {
        path: 'home',
        loadChildren: './home/home.module#HomePageModule',
        canActivate: [AuthGuard],
    },
    {
        path: 'map/create',
        loadChildren: './create/create.module#CreatePageModule',
        canActivate: [AuthGuard],
    },
    {
        path: 'maps',
        loadChildren: './maps/maps.module#MapsPageModule',
        canActivate: [AuthGuard],
        resolve: { maps: MapsResolver },
    },
    {
        path: 'map/:id',
        loadChildren: './map/map.module#MapPageModule',
        canActivate: [AuthGuard],
        resolve: { map: MapResolver },
    },
    {
        path: 'map/dashboard/:id',
        loadChildren: './dashboard/dashboard.module#DashboardPageModule',
        canActivate: [AuthGuard],
        resolve: { dashData: MapDashboardResolver },
    },
    {
        path: 'user',
        loadChildren: './user/user.module#UserPageModule',
        canActivate: [],
    },
    {
        path: 'leaderboard',
        loadChildren: './leaderboard/leaderboard.module#LeaderboardPageModule',
    },
    {
        path: 'leaderboard/:budget',
        loadChildren: './leaderboard/leaderboard.module#LeaderboardPageModule',
        canActivate: [],
    },
    {
        path: 'error',
        loadChildren: './error/error.module#ErrorPageModule'
    },
    {
        path: 'data-export',
        canActivate: [AuthGuard],
        loadChildren: './data-export/data-export.module#DataExportPageModule'
    },
    // { path: '**', loadChildren "./pagenotfound"}
];

@NgModule({
    imports: [
        // Note: PreloadAllModules can trigger loading of lazy modules at startup. Disable preloading
        // temporarily to diagnose freezes related to module initialization (e.g. translation).
        RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
    ],
    exports: [RouterModule],
    providers: [MapResolver, MapsResolver],
})
export class AppRoutingModule { }
